import React, { useState } from 'react';
import AuthService from '../services/AuthService';
import './Auth.css';

const EmailVerification = ({ email, onVerificationSuccess, onBackToSignup }) => {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await AuthService.confirmSignUp(email, code);
      onVerificationSuccess();
    } catch (err) {
      setError(err.message || 'Verification failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1 className="auth-title">AI Sales Coach</h1>
          <p className="auth-subtitle">Powered by Amazon Nova Sonic</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          <h2>Verify Your Email</h2>
          
          <p className="verification-text">
            We've sent a verification code to <strong>{email}</strong>. 
            Please check your email and enter the code below.
          </p>
          
          {error && <div className="error-message">{error}</div>}
          
          <div className="form-group">
            <label htmlFor="code">Verification Code</label>
            <input
              type="text"
              id="code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              required
              disabled={loading}
              placeholder="Enter 6-digit code"
              maxLength="6"
            />
          </div>

          <button 
            type="submit" 
            className="connect-btn auth-btn"
            disabled={loading || code.length !== 6}
          >
            {loading ? 'Verifying...' : 'Verify Email'}
          </button>

          <div className="auth-switch">
            Didn't receive the code?{' '}
            <button 
              type="button" 
              className="link-btn"
              onClick={onBackToSignup}
            >
              Back to Sign Up
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EmailVerification;
